import React, {useState, useEffect, useRef} from "react";
import InfoBox from "./InfoBox";
import assets from '../assets/imgs';

function CommuteBox({style, icon: Icon, text, onClick, btnText, detail, disabled = false, showInfo= false, infoDescription = ""}) {
  const [showModal, setShowModal] = useState(false);
  const popupRef = useRef(null);

  const closeModal = ()=>{
    setShowModal(false);
  }
  const handleOverlayClick = (e)=>{
    if(e.target === e.currentTarget){
      closeModal();
    }
  }

  // ESC 키로 모달 닫기
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        closeModal();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  const openModal = () =>{
    setShowModal(true);
  }
  
  return ( 
    <>
      <div style={{...styles.container, ...style}}>
        <div style={styles.header}>
          <div style={styles.iconBox}>
            {Icon && <Icon style={{color:"var(--primary-crimson_30)", width: "64%"}}/>}
          </div>
          <div style={styles.headerTextSection}>
            <div style={{display: "flex", gap: "10px", alignItems: "center"}}> 
              <p className="font-s-head4-bold" style={styles.headerText}>{text}</p>
              {showInfo &&(
                <div style={styles.infoIcon} onClick={openModal}>
                  <assets.icons.info />
                </div>
              )}
            </div>
            {detail &&(
              <p className="font-s-head3-semibold" style={styles.headerText}>{detail}</p>
            )}            
          </div>
        </div>
        {onClick && (
          <div onClick={onClick} style={{...styles.btnClick,
            backgroundColor: disabled ? "var(--grayscale_40)" : "var(--primary-crimson_60)",
            color: disabled ? "var(--grayscale_60)": "var(--grayscale-cool_10)",
            cursor: disabled ? "default" : "pointer",
          }} className="font-body3-bold">
            {btnText}
          </div>
        )}
      </div>  
      {(showInfo && showModal) && (
        <div style={styles.overlay} onClick={handleOverlayClick}>
          <div style={styles.modal} ref={popupRef}>
            {infoDescription}
          </div>
        </div>        
      )}
    </>
    
  );
}

const styles = {
  container:{
    borderRadius: "8px",
    height: "100%",
    boxSizing: "border-box",
    flex:"1",
    display: "flex",
    padding: "24px",  
    backgroundColor: "white",
    alignItems:"center"
  },
  header:{
    display:"flex",
    flex: 1,
    gap:"12px",
    height: "100%"
  },
  headerTextSection:{
    display:"flex",
    flexDirection: "column",
    gap:"6px",
    justifyContent:"center",
  },
  headerText:{
    color: "var(--grayscale_90)"
  },
  iconBox:{
    height:"100%",
    aspectRatio: 1,
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
  },
  btnClick:{
    backgroundColor: "var(--primary-crimson_60)",
    borderRadius: "4px",
    width: "134px",
    height: "50px",
    color: "var(--grayscale-cool_10)",
    display:"flex",
    alignItems:"center",
    justifyContent: "center",
    cursor:"pointer",
  },
  infoIcon:{
    width: "24px",
    height: "24px",
    cursor: "pointer",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // 반투명 배경
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "white",
    borderRadius: "25px",
    padding: "20px 40px",
    display: "flex",
    alignItems:"center",
    justifyContent: "center",
    minHeight: "50px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    position: "relative",
  },
};

export default CommuteBox;